import Cropper from '../../3rd_party/cropperjs/cropper.js';

export default class pegPhotoEditor extends HTMLElement {
	//TODO:is this still needed?
	constructor() {
		super();
		this.cropper = null;
		this.abortController = null;
	}

	connectedCallback() {
		this.abortController = new AbortController();
	}

	disconnectedCallback() {
		this.destroyCropper();
		this.abortController.abort();
	}

	startCropper(photo) {
		this.initCropperPlugin(photo);
		const signal = this.abortController.signal;
		document.body.addEventListener('keydown', (event) => this.onArrowKeys(event.code), { signal });

		this.querySelector('#rotateLeft').addEventListener('click', () => this.cropper.rotate(-90), { signal });
		this.querySelector('#rotateRight').addEventListener('click', () => this.cropper.rotate(90), { signal });
		this.querySelector('#zoomPlus').addEventListener('click', () => this.cropper.zoom(0.1), { signal });
		this.querySelector('#zoomMinus').addEventListener('click', () => this.cropper.zoom(-0.1), { signal });
	}

	destroyCropper() {
		this.cropper?.destroy();
		this.querySelector('#imageContainer img')?.remove();
	}

	initCropperPlugin(photo) {
		const image = Object.assign(document.createElement('img'), { src: '', alt: '' });
		this.querySelector('#imageContainer').appendChild(image);

		image.onload = () => {
			this.cropper = new Cropper(image, {
				aspectRatio: 2 / 3,
				minCropBoxHeight: 280,
				minContainerHeight: 380,
				viewMode: 1,
				checkCrossOrigin: false,
				dragMode: 'move',
				cropBoxMovable: false,
				cropBoxResizable: false,
			});
		};
		image.src = photo;
	}

	onArrowKeys(keyCode) {
		switch (keyCode) {
			case 'ArrowLeft':
				event.preventDefault();
				this.cropper.move(1, 0);
				break;

			case 'ArrowUp':
				event.preventDefault();
				this.cropper.move(0, 1);
				break;

			case 'ArrowRight':
				event.preventDefault();
				this.cropper.move(-1, 0);
				break;

			case 'ArrowDown':
				event.preventDefault();
				this.cropper.move(0, -1);
				break;
		}
	}

	saveAsImage() {
		return new Promise((resolve, reject) => {
			try {
				// do not delete following line: BUG-16950 https://github.com/fengyuanchen/cropperjs/issues/1036#issuecomment-1500289959
				this.cropper.getCroppedCanvas({ imageSmoothingEnabled: false, maxHeight: 2880 });
				const croppedCanvas = this.cropper.getCroppedCanvas({ imageSmoothingEnabled: false, maxHeight: 2880 });
				croppedCanvas.toBlob(resolve, 'image/jpeg');
			} catch (error) {
				reject(error);
			}
		});
	}
}
